import { render, staticRenderFns } from "./ProdAddMain.vue?vue&type=template&id=11693a9b&scoped=true&"
import script from "./ProdAddMain.vue?vue&type=script&lang=js&"
export * from "./ProdAddMain.vue?vue&type=script&lang=js&"
import style0 from "./ProdAddMain.vue?vue&type=style&index=0&id=11693a9b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11693a9b",
  null
  
)

export default component.exports